import { StyleSheet, Dimensions, Platform } from 'react-native';

import { isIPhoneDeviceWithNotch } from '@vfgroup-oneplatform/foundation/Utils/Platform';

import { TRAY_TYPES } from '../../Utils/TrayTypesConstants';

const screenWidth = Dimensions.get('window').width;

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();
let tobiHeight = screenWidth / 5.294
if (screenWidth >= 600) {
  tobiHeight = 90
}

export default StyleSheet.create({
  containerStyle: {
    alignItems: 'flex-start',
    bottom: 0,
    flexDirection: 'row',
    flex: 1,
    height: 87,
    justifyContent: 'space-between',
    marginBottom: getComputedStyle(document.documentElement).getPropertyValue("--sab")?.split('px')[0] > 0 ? getComputedStyle(document.documentElement).getPropertyValue("--sab") : 20,
    position: 'absolute',
    width: screenWidth,
    zIndex: 2,
    paddingTop: 41,
  },
  injectedView: {
    flex: 0,
    borderRadius: screenWidth / 11,
    width: screenWidth / 5.294,
    height: screenWidth / 5.294,
    left: screenWidth / 2 - (1 / 2) * (screenWidth / 5.294),
    position: 'absolute',
    zIndex: 1,
  },
  toBiIcon: {
    height: tobiHeight,
    width: tobiHeight
  },
  toBiStyle: trayType => ({
    width: screenWidth / 5.294,
    ...Platform.select({
      ios: {
        bottom: isIPhoneWithNotch ? 38 : 23,
      },
      android: {
        bottom: trayType === TRAY_TYPES.SECONDLEVEL ? 50 : 23,
      },
      web: {
        bottom: trayType === TRAY_TYPES.SECONDLEVEL ? tobiHeight + 5 : tobiHeight + 5
      }
    }),
    left: screenWidth / 2 - (1 / 2) * (screenWidth / 5.294),
    zIndex: 1,
    position: 'fixed'
  }),
  tabsContainerWithNotch: {
    bottom: -20,
  },
  TobiPressView: {
    flex: 1,
  },
  tabStyle: (index, length) => ({
    // marginRight: index === 0 ? 0 : 15,
    // marginLeft: index === length - 1 ? 0 : 15,
  }),
});
